// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderPopup_container__1coky","selector":"OrderPopup_selector__1xniJ","actionContainer":"OrderPopup_actionContainer__30nFB"};